export * from '@primeuix/themes/aura/divider';
export { default } from '@primeuix/themes/aura/divider';
